import { PlayerPoolFiltres } from '../../Fantasy';

export class PlayerComparisonPlayerPoolFilters extends PlayerPoolFiltres{
	getFilterByPriceOptions() {
		return [
			{ key: '', value: 'By Price' },
			{ key: '800-99999', value: '800k+' },
			{ key: '600-800', value: '600-800k' },
			{ key: '400-600', value: '400-600k' },
			{ key: '300-400', value: '300-400k' },
			{ key: '0-300', value: '0-300k' },
		];
	}
}

export default PlayerComparisonPlayerPoolFilters;